import { isEmpty, last } from '../helpers/helpers'

export const groupByMaxAggregatedLength = (items: string[], maxLength: number): string[][] => {
  const groups: string[][] = [[]]
  let aggregatedSizeLastGroup = 0
  for (const item of items) {
    if (aggregatedSizeLastGroup + item.length > maxLength) {
      if (aggregatedSizeLastGroup === 0) {
        last(groups).push(item)
        groups.push([])
        aggregatedSizeLastGroup = 0
      } else {
        groups.push([item], [])
        aggregatedSizeLastGroup = 0
      }
    } else {
      last(groups).push(item)
      aggregatedSizeLastGroup += item.length
    }
  }
  if (isEmpty(last(groups))) {
    groups.pop()
  }
  return groups
}

const FIREFOX_UNHANDLED_FAILED_NETWORK_MESSAGE = 'NetworkError when attempting to fetch resource.'
const GENERIC_UNHANDLED_FAILED_NETWORK_MESSAGE = 'Failed to fetch'
const SAFARI_UNHANDLED_FAILED_NETWORK_MESSAGE = 'Load failed'
const GENERIC_ABORTED_REQUEST_MESSAGE = 'The user aborted a request'
const FIREFOX_ABORTED_REQUEST_MESSAGE = 'The operation was aborted'
const SAFARI_ABORTED_REQUEST_MESSAGE = 'Fetch was aborted'
const THIRD_PARTY_SCRIPT_ERROR = 'Script error.'
const VIEWER_COMMON_ERRORS = [
  'byte length of Uint32Array should be a multiple of 4',
  'byte length of Float32Array should be a multiple of 4',
  'viewer component unmounted',
  'ResizeObserver loop'
]
const NEXTJS_COMMON_ERRORS = [
  // It happens mostly to crawlers because they use cached version of the page. It happens when a link is clicked and the page does not exist anymore, but the crawler still tries to access it, getting a 404 error and throwing this error.
  'Failed to load static props',

  // It happens when the user navigates to another page before the current page is fully loaded. It is not an error, it is just a warning that the current page is being unmounted.
  'Loading initial props cancelled',
  'Fetch is aborted'
]
export const WARNING_MESSAGES = [
  FIREFOX_UNHANDLED_FAILED_NETWORK_MESSAGE,
  GENERIC_UNHANDLED_FAILED_NETWORK_MESSAGE,
  SAFARI_UNHANDLED_FAILED_NETWORK_MESSAGE,
  GENERIC_ABORTED_REQUEST_MESSAGE,
  FIREFOX_ABORTED_REQUEST_MESSAGE,
  SAFARI_ABORTED_REQUEST_MESSAGE,
  THIRD_PARTY_SCRIPT_ERROR,
  ...VIEWER_COMMON_ERRORS,
  ...NEXTJS_COMMON_ERRORS
]
